exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".previewContainer-86784b47{margin:30px auto 0 auto;width:333px;border-radius:45px;border:5px solid #30323A;background-color:#212121}.previewInner-79c928fa{margin:-3px;border:2px solid black;border-radius:45px;background-color:#212121;padding:60px 14px 100px 14px}.previewIframe-cdad3c1f{height:500px;width:100%;margin:0;padding:0;border:none;border-radius:4px}\n", ""]);

// Exports
exports.locals = {
	"previewContainer": "previewContainer-86784b47",
	"previewInner": "previewInner-79c928fa",
	"previewIframe": "previewIframe-cdad3c1f"
};